/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upper_Flaky_Bulldog_SoarInputs */

const fr_upper_flaky_bulldog_soar = /** @type {(inputs: Upper_Flaky_Bulldog_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image de profil`)
};

/**

* @param {Upper_Flaky_Bulldog_SoarInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const upper_flaky_bulldog_soar = /** @type {((inputs?: Upper_Flaky_Bulldog_SoarInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upper_Flaky_Bulldog_SoarInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_upper_flaky_bulldog_soar(inputs)
});